import './Loader.css'

function Loader() {
    return (
        <div className="lds-hourglass"></div>
    );
}

export default Loader;